<script setup lang="ts">
import { FairIconContainer } from '@/ui/primitives/FairIconContainer'
import { FAIR_TOAST_BOTTOM_OFFSET_PX } from '@/ui/tokens/fair-toast.data'
import { useFairToast } from './useFairToast'

const { toasts, dismiss } = useFairToast()

function handleLinkClick(id: number, onLinkClick?: () => void) {
  onLinkClick?.()
  dismiss(id)
}
</script>

<template>
  <Teleport to="body">
    <div
      class="fair-toast-host"
      :style="{ '--fair-toast-bottom': `${FAIR_TOAST_BOTTOM_OFFSET_PX}px` }"
      aria-live="polite"
      aria-relevant="additions"
    >
      <TransitionGroup name="fair-toast">
        <div
          v-for="item in toasts"
          :key="item.id"
          class="fair-toast"
          :class="`fair-toast--${item.tone}`"
          :style="{ '--fair-toast-life': `${item.life}ms` }"
          role="status"
        >
          <p class="fair-toast__content">
            <FairIconContainer
              v-if="item.showIcon"
              class="fair-toast__icon"
              :name="item.tone === 'warning' ? 'error' : 'check'"
              :size="12"
            />
            <span class="fair-toast__message">{{ item.message }}</span>
          </p>
          <button
            v-if="item.linkLabel"
            type="button"
            class="fair-toast__link"
            @click="handleLinkClick(item.id, item.onLinkClick)"
          >
            {{ item.linkLabel }}
          </button>
          <span
            v-if="item.life > 0"
            class="fair-toast__timer"
            aria-hidden="true"
          />
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>
